let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("alRHJ")).then(() => parcelRequire('6g6AR'));